/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions, FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes.js.map